import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  id: number
}

export default function useGetOneEdgeServer({enabled, id}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_AGE_AND_GENDER, enabled, id],
    queryFn: async () => (await api.company.getOneEdgeServer(id)).data.data,
  })

  return query
}
